module.exports = __webpack_public_path__ + "static/fonts/ionicons.2c159d0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/megamenu/fonts/ionicons.woff
// module id = MYk3
// module chunks = 0